module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Sr_Session2.74c6523a.jpg";